import { createSlice } from "@reduxjs/toolkit";

/**
 * 파일명: userSlice.js
 * 작성자: 권도훈
 * 작성일자: 23.04.06
 * 설명: 사용자 정보
 */
const userSlice = createSlice({
  name: "userSlice",
  initialState: {
    userId: "",
    userNm: "",
    email: "",
    adminYn: "",
    adminType: "",
    campus: "",
    campusCd: "",
  },
  reducers: {
    insertUserInfo: (state, action) => {
      state.userId = action.payload.userId;
      state.userNm = action.payload.userNm;
      state.email = action.payload.email;
      state.adminYn = action.payload.adminYn;
      state.adminType = action.payload.adminType || "";
      state.campus = action.payload.campus || "";
      state.campusCd = action.payload.campusCd || "";
    },
    deleteUserInfo: (state) => {
      state.userId = "";
      state.userNm = "";
      state.email = "";
      state.adminYn = "";
      state.adminType = "";
      state.campus = "";
      state.campusCd = "";
    },
  },
});

export default userSlice;

export const { insertUserInfo, deleteUserInfo } = userSlice.actions;
